import React from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import styles from './ChatHistory.module.css';
import { BackButton } from 'components/Map/Components/BackButton';
import { AnimatedButton } from 'components/Map/AnimatedButton';
import { ReduxState } from 'ducks';
import { useSelector } from 'react-redux';
import { ChatConversation } from 'models/chatConversation';

interface ChatHistoryProps {
  onBack: () => void;
  onSelectThread: (threadId: string) => void;
  onNewThread: () => void;
}

export const ChatHistory: React.FC<ChatHistoryProps> = ({
  onBack,
  onSelectThread,
  onNewThread,
}) => {
  const { t, i18n } = useTranslation();

  const chatThreads = useSelector((state: ReduxState) => state.chatConversations.conversations);

  const hasHistory = chatThreads.length > 0;

  const getConversationTitle = (conversation: ChatConversation) => {
    const firstChat = conversation.messages[0];
    return firstChat?.content || t('New Conversation');
  };

  return (
    <div className={styles.historyView}>
      <div className={styles.header}>
        <BackButton
          onClick={onBack}
          headerContent={<h2 className={styles.title}>{t('Chat History')}</h2>}
        />
      </div>
      <div className={styles.threadList}>
        <AnimatedButton
          type="button"
          className={styles.newThreadButton}
          clickedClassName={styles.clicked}
          onClick={onNewThread}
        >
          <img src="/static/images/map/new.svg" className={styles.newThreadIcon} alt="new" />
          {t('Start New Conversation')}
        </AnimatedButton>
        {!hasHistory && <p className={styles.threadPreview}>{t('No past conversations yet.')}</p>}
        {hasHistory &&
          chatThreads.map((conversation) => (
            <div
              key={conversation.id}
              className={styles.threadItem}
              onClick={() => onSelectThread(conversation.id)}
            >
              <img src="/static/images/map/thread.svg" className={styles.threadIcon} alt="thread" />
              <div className={styles.threadContent}>
                <div className={styles.threadHeader}>
                  <h3 className={styles.threadTitle}>{getConversationTitle(conversation)}</h3>
                  <span className={styles.threadDate}>
                    {moment(conversation.updated_date_time_utc)
                      .locale(i18n.language)
                      .format('MMM D')}
                  </span>
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};
